// import React from "react";
import CryptoJS from "crypto-js";
// import {baseUrl, baseUrlSave, createBookingAPI, getAvailableBookingSlotAPI, setNewPasswordAPI, getAvailableServicesAPI, azureApiHeader, azureApiValue, phpBaseUrl, encryptionIv, encryptionKey} from '../../components/constant'
import {phpBaseUrl, encryptionIv, encryptionKey} from '../../components/constant'
import {resolve} from './resolver'

export async function generateToken(){
    
    try{
        return await resolve(fetch(phpBaseUrl+'generateToken.php', {
                method: 'GET',
                headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
                } 
            }).then(results =>
                {  
                    return results.json()
                }    
            )).then(response => {
                if(response.data.error === true){
                    return response.data;
                }else{
                    const token = response.data.token;
                    const fkey = CryptoJS.enc.Utf8.parse(encryptionKey);
                    const fiv = CryptoJS.enc.Utf8.parse(encryptionIv);

                    const enc = CryptoJS.AES.encrypt(token, fkey, {
                            iv: fiv,
                            mode: CryptoJS.mode.CBC,
                            padding: CryptoJS.pad.Pkcs7,
                    });

                    const encryptedData = enc.ciphertext.toString(CryptoJS.enc.Base64);
                    return encryptedData;
                }
            })
    }catch(error){
        return [];
    }
}

export async function getAllServiceList(token){
    try{
        return await resolve(fetch(phpBaseUrl+'getAvailableServices.php', {    
                method: 'GET',
                headers: {
                'Content-Type': 'application/json',
                'token': token
                } 
            }).then(results =>
                (results.status === 200?results.json(): [])
            )).then(response => {
                if(response.data.error === true){
                    return response.data;
                }else{
                    return response;
                }
            })
    }catch(error){
        return [];
    }
}

export async function getAllServiceProviderList(payload, token){
    try{
        return await resolve(fetch(phpBaseUrl+'getAvailableBookingSlots.php', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'token': token
            },
            body: payload 
        }).then(results =>
            (results.status === 200?results.json(): [])
        )).then(response => {
            if(response.data.error === true){
                return response.data;
            }else{
                return response;
            }
        })
    }catch(error){
        return [];
    }
}

export async function savewebappdata(payload, token){
    try{
        return await resolve(fetch(phpBaseUrl+'createBooking.php', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'token': token
            },
            body: payload
        }).then(results =>
            (results.status === 200?{status:true}: {status:false})
        )).then(response => {
            if(response.data.error === true){
                return response.data;
            }else{
                return response;
            }
        })
    }catch(error){
        return [];
    }
}